import {Pipe, PipeTransform} from '@angular/core';

/**
 * Pipe to shorten project names for display purposes.
 * Add more mappings to the 'shortNames' object as needed.
 */
@Pipe({
    name: 'projectShortName'
})
export class ProjectShortNamePipe implements PipeTransform {
    private shortNames: {[key: string]: string} = {
        'D. van der Steen B.V': 'DvdS'
        // Add more mappings here as needed
    };

    transform(value: string): string {
        if (!value) return '';
        return this.shortNames[value] || value;
    }
}

